import { Dialog } from "primereact/dialog";
import { Button } from "primereact/button";
import { InputNumber } from "primereact/inputnumber";
import { useEffect, useRef, useState } from "react";
import { IDropdown, ILead, ILeadReq } from "../../models/BaseModel";
import { Fetch } from "../../shared/Fetch";
import { Toast } from "primereact/toast";

interface Iprops {
    singleData: ILead;
    open: boolean;
    hideDialog: () => void;
    toast: any;
}

export const UpdateInvoiceRate = (props: Iprops) => {
    const [leadReq, setLeadReq] = useState<ILeadReq>();
    const [submitting, setSubmitting] = useState(false);

    const [roomTypes, setRoomTypes] = useState<IDropdown[]>([]);
    const [vehicleTypes, setVehicleTypes] = useState<IDropdown[]>([]);
    const [pickupLocations, setPickupLocations] = useState<IDropdown[]>([]);
    const toast = useRef<any>(null);

    useEffect(() => {
        if (props.singleData.id) loadLeadRequirement(props.singleData.id);
        loadLookups();
    }, [props.singleData]);

    const loadLeadRequirement = async (leadId: number) => {
        const response = await Fetch(`leadreq/${leadId}`, "GET", null, null, props.toast);
        if (response) {
            const req: ILeadReq = await response.json();
            setLeadReq(req);
        }
    };

    const loadLookups = async () => {
        // const roomResp = await Fetch("roomtype/dropdown", "GET", null, null, props.toast);
        // const vehicleResp = await Fetch("vehicletype/dropdown", "GET", null, null, props.toast);
        // const pickupResp = await Fetch("pickuplocation/dropdown", "GET", null, null, props.toast);

        // if (roomResp) setRoomTypes(await roomResp.json());
        // if (pickupResp) setPickupLocations(await pickupResp.json());
    };

    const onHide = () => {
        props.hideDialog();
        setLeadReq(undefined);
    };

    const handleRoomPriceChange = (index: number, field: "price" | "mattressPrice", value: number) => {
        if (!leadReq) return;
        const updatedRooms = [...(leadReq.rooms || [])];
        if (field === "price") updatedRooms[index].price = value;
        else updatedRooms[index].mattressPrice = value;
        setLeadReq({ ...leadReq, rooms: updatedRooms });
    };

    // const handleBoatingPriceChange = (index: number, value: number) => {
    //     if (!leadReq) return;
    //     const updatedBoatings = [...(leadReq.boatings || [])];
    //     updatedBoatings[index].price = value;
    //     setLeadReq({ ...leadReq, boatings: updatedBoatings });
    // };

    const handleVehiclePriceChange = (pickIndex: number, vehicleIndex: number, value: number) => {
        if (!leadReq) return;
        const updatedPickAndDrops = [...(leadReq.pickAndDrops || [])];
        updatedPickAndDrops[pickIndex].vehicles![vehicleIndex].ratePerKm = value;
        setLeadReq({ ...leadReq, pickAndDrops: updatedPickAndDrops });
    };

    const handleFoodPriceChange = (key: string, value: number) => {
        if (!leadReq) return;
        setLeadReq({ ...leadReq, [`${key}Price`]: value } as any);
    };

    const onSubmit = async () => {
        if (!leadReq) return;
        setSubmitting(true);
        try {
            await Fetch(`leadreq/update/${leadReq.id}`, "POST", leadReq, null, props.toast);
            toast.current?.show({ severity: 'success', summary: 'Updated', detail: 'Invoice Updated Successfully' });
            setTimeout(() => {
                onHide();
            }, 1000);

        } catch (error) {
            console.error(error);
            toast.current?.show({ severity: "error", summary: 'Error', detail: "Failed to update invoice." });
        } finally {
            setSubmitting(false);
        }
    };


    if (!leadReq) return null;

    return (
        <>
            <Dialog visible={props.open} style={{ width: '40vw', maxWidth: '900px' }} header={`Update Invoice (${props.singleData.contactName})`} modal onHide={onHide}  >
                <div className="p-fluid">
                    {/* Rooms */}
                    <h4 className="mb-2">Rooms</h4>
                    <div className="p-grid p-align-center">
                        {leadReq.rooms?.map((room, index) => {
                            const roomType = roomTypes.find(r => r.id === room.roomTypeId);
                            return (
                                <div key={index} className="p-col-12 p-md-6 mb-3">
                                    <label className="block mb-1">{roomType?.name || `Room ${index + 1}`}</label>
                                    <InputNumber className="w-full mb-2" value={room.price} onValueChange={(e) => handleRoomPriceChange(index, "price", e.value || 0)} mode="currency" currency="INR" locale="en-IN" />
                                    <label className="block mb-1">Mattress Price</label>
                                    <InputNumber className="w-full" value={room.mattressPrice} onValueChange={(e) => handleRoomPriceChange(index, "mattressPrice", e.value || 0)} mode="currency" currency="INR" locale="en-IN" />
                                </div>
                            );
                        })}
                    </div>

                    {/* Boating */}
                    <h4 className="mb-2 mt-4">Boating</h4>
                    {/* <div className="p-grid p-align-center">
                        {leadReq.boatings?.map((b, index) => {
                            const boatingLocation = boatingLocations.find(bl => bl.id === b.boatingLocationId);
                            return (
                                <div key={index} className="p-col-12 p-md-6 mb-3">
                                    <label className="block mb-1">{boatingLocation?.name || `Boating ${index + 1}`}</label>
                                    <InputNumber className="w-full" value={b.price} onValueChange={(e) => handleBoatingPriceChange(index, e.value || 0)} mode="currency" currency="INR" locale="en-IN" />
                                </div>
                            );
                        })}
                    </div> */}

                    {/* Pick & Drop */}
                    <h4 className="mb-2 mt-4">Pick & Drop</h4>
                    <div className="p-grid p-align-center">
                        {leadReq.pickAndDrops?.map((pd, pIndex) => (
                            pd.vehicles?.map((v, vIndex) => {
                                const vehicleType = vehicleTypes.find(vt => vt.id === v.vehicleTypeId);
                                const pickupLocation = pickupLocations.find(pl => pl.id === pd.pickupLocationId);
                                return (
                                    <div key={`${pIndex}-${vIndex}`} className="p-col-12 p-md-6 mb-3">
                                        <label className="block mb-1">
                                            {vehicleType?.name} | {pickupLocation?.name} ({pd.tripType.toUpperCase()})
                                        </label>
                                        <InputNumber className="w-full" value={v.ratePerKm} onValueChange={(e) => handleVehiclePriceChange(pIndex, vIndex, e.value || 0)} mode="currency" currency="INR" locale="en-IN" />
                                    </div>
                                );
                            })
                        ))}
                    </div>

                    {/* Save / Close Buttons */}
                    <div className="p-grid mt-4">
                        <div className="p-col-12 flex justify-content-end gap-2">
                            <Button label="Save" loading={submitting} onClick={onSubmit} className="p-button-success" />
                            <Button label="Close" onClick={onHide} className="p-button-secondary" />
                        </div>
                    </div>
                </div>
            </Dialog>
            <Toast ref={toast} position="top-right" />
        </>
    );
};
